var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ZDJPage',{attrs:{"target-uri":_vm.$route.path.substring('/gamezone'.length)}})
}
var staticRenderFns = []

export { render, staticRenderFns }